import { render, staticRenderFns } from "./TemplateCertification.vue?vue&type=template&id=ef79f6ce&scoped=true"
import script from "./TemplateCertification.vue?vue&type=script&lang=js"
export * from "./TemplateCertification.vue?vue&type=script&lang=js"
import style0 from "./TemplateCertification.vue?vue&type=style&index=0&id=ef79f6ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef79f6ce",
  null
  
)

export default component.exports